import { Environment, EnvironmentFlags } from '@ffx/common';

export type FlagState = {
    environments: Environment[];
    environmentFlags: EnvironmentFlags;
    selectedEnvironmentId: string;
    triggerRefreshFlagsEffect: boolean;
    flagsLoading: boolean;
    errorMessage: string;
    publishFlagsLoading: boolean;
};

export const initialState: FlagState = {
    environments: [],
    environmentFlags: {
        environment: {
            id: '',
            name: '',
            cssColour: ''
        },
        flags: []
    },
    selectedEnvironmentId: '',
    triggerRefreshFlagsEffect: false,
    flagsLoading: false,
    errorMessage: '',
    publishFlagsLoading: false
};
